import PaymentSuccessGif from "../../assets/gifs/payment-success.gif";

export default function OrderSuccess() {

    return (
        <div
            style={{
                height: "100vh",
                width: "100vw",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <img
                src={PaymentSuccessGif}
                alt="Payment Success"
                style={{
                    height: 'auto',
                    width: 'auto',
                    maxWidth: '100%',
                    maxHeight: '100%',
                }}
            />
            <h2>
                Payment Successful!
            </h2>

            <div
                className='d-flex flex-wrap mt-3' style={{marginBottom: 100}}
            >
                <btn onClick={() => {
                    window.location.href = `${process.env.REACT_APP_HOME}/dashboard`;
                }} className='btn btn-primary mt-4'>
                    Go to Dashboard
                </btn>
            </div>

        </div>
    )
}